export default {
  categories: [],
  categoriesFetched: false
}



// WEBPACK FOOTER //
// ./src/components/category/store/state.js